export interface INews {
  newsItemId: number | string;
  category: ENewsCategory;
  subject: string;
  message: string;
  displayDate: string;
  takeDownDate: string;
  dateCreated: string;
  customPageId: number | null;
  customPageSlug: string | null;
  allEmployees: boolean;
  allVendors: boolean;
  targetedEmployees: number;
  targetedVendors: number;
  newsItemType: ENewsContentType;
  externalUrl?: string;
  fileData?: string;
  unread?: boolean;
  allHomeowners: boolean;
  targetedHomeowners: number;
  allSales: boolean;
  targetedSales: number;
  isVideo: boolean;
}
export interface INewsDetail {
  newsItemId: number | string;
  category: string;
  subject: string;
  message: string;
  displayDate: string;
  takeDownDate: string;
  dateCreated: string;
  customPageId: number | null;
  customPageSlug: string | null;
  visibilities: {
    value: string;
    description: string;
    shorthand: string;
  }[];
  usernames: string[];
  vendors: {
    vendorId: number;
    vendorName: string;
  }[];
  newsItemType: string;
  externalUrl?: string;
  fileData?: string;
  homeownerIds: number[];
  salesAgentIds: number[];
  subcontractorTypeIds: number[];
}

export interface INewsPost {
  category: string;
  subject: string;
  message: string;
  displayDate: string;
  takeDownDate: string;
  customerPageId?: number;
  newsItemType: string;
  visibilities: string[];
  usernames: string[];
  vendorIds: number[];
  externalUrl?: string;
  fileData?: string;
  homeownerIds: number[];
  salesAgentIds: number[];
}

export interface INewsVisibilities {
  value: string;
  description: string;
  shorthand: string;
}

export enum ENewsContentType {
  AttachedFile = 'AttachedFile',
  ExternalUrl = 'ExternalUrl',
  CustomPage = 'CustomPage',
  MessageOnly = 'MessageOnly'
}

export enum ENewsCategory {
  Alert = 'Alert',
  Feature = 'Feature',
  Announcement = 'Announcement'
}
